import { softDeleteAppointment } from '@ax/service';
import { SoftDeleteAppointmentInput } from '@ax/service/src/appointment-interface';
import { useMutation } from '@tanstack/react-query';

export function useSoftDeleteAppointmentApi() {
  const softDeleteAppointmentMutation = useMutation({
    mutationKey: ['soft-delete-appointment'],
    mutationFn: (data: SoftDeleteAppointmentInput) => softDeleteAppointment(data),
    onError: (error: any) => {
      return error;
    },
  });

  return softDeleteAppointmentMutation;
}
